import { workerTheme } from "./worker.theme";

export const THEMES = {
  worker: workerTheme,
};
